import './DatePicker.scss';
import * as React from 'react';
import da from 'date-fns/locale/da';
import ReactDatePicker, { ReactDatePickerProps } from 'react-datepicker';

const DatePicker = (props: ReactDatePickerProps) => (
  <ReactDatePicker
    locale={da}
    {...props}
  />
);

export default DatePicker;




// WEBPACK FOOTER //
// ./src/components/DatePicker/index.tsx